import { atom, useRecoilValue } from 'recoil'
export type ManageMenuStoreType = {
    isOpen: boolean | null | undefined
}
export const manageMenuStore = atom<ManageMenuStoreType>({
    key: 'manageMenuStore',
    default: {
        isOpen: false,
    },
})

const useManageMenuStore = () => {
    const appAlertMessageState = useRecoilValue(manageMenuStore)
    return {
        ...appAlertMessageState,
    }
}

export default useManageMenuStore
